const VolumeDetails = ({ volume, avgPrice, lowerCircuit, upperCircuit, ltq, ltt }) => {
    const formatLtt = (val) => {
        if (!val) return "N/A";
        try {
            const d = new Date(val);
            return d.toISOString().split(".")[0].replace("T", " ");
            // → "2025-10-01 09:56:21"
        } catch {
            return val;
        }
    };

    return (
        <div className="volume-details">
            <div className="volume-details1">
                <div className="volume-item">
                    <div className="volume-label">Volume:</div>
                    <div className="volume-value">{volume.toLocaleString()}</div>
                </div>
                <div className="volume-item">
                    <div className="volume-label">Lower Circuit:</div>
                    <div className="volume-value">{lowerCircuit.toFixed(2)}</div>
                </div>
                <div className="volume-item">
                    <div className="volume-label">LTQ:</div>
                    <div className="volume-value">{ltq}</div>
                </div>
            </div>
            <div className="volume-details1">
                <div className="volume-item">
                    <div className="volume-label">Avg. Price:</div>
                    <div className="volume-value">{avgPrice.toFixed(2)}</div>
                </div>
                <div className="volume-item">
                    <div className="volume-label">Upper Circuit:</div>
                    <div className="volume-value">{upperCircuit.toFixed(2)}</div>
                </div>
                <div className="volume-item">
                    <div className="volume-label">LTT:</div>
                    <div className="volume-value">{formatLtt(ltt)}</div>
                </div>
            </div>
        </div>
    );
};

export default VolumeDetails;
